// The crew app with no network at start (STAGE_5 5.1): the bundle came from the tablet's
// own cache, the server cannot be reached to restore the session. Said plainly, and
// retried by itself as soon as the network is back - nobody has to press anything.

import { DisconnectOutlined } from '@ant-design/icons';
import { Flex, Typography, theme } from 'antd';
import { useEffect } from 'react';

import { useAuth } from '@/features/auth/authContext';
import { ru } from '@/i18n/ru';
import { useThemeMode } from '@/theme/themeContext';

import { CrewTheme } from './crewTheme';
import { MainButton } from './CrewScreen';

const c = ru.crew;

export function CrewOffline() {
  const { retryRestore } = useAuth();
  const { prefer } = useThemeMode();
  const { token } = theme.useToken();

  useEffect(() => {
    prefer('dark');
  }, [prefer]);

  useEffect(() => {
    window.addEventListener('online', retryRestore);
    return () => {
      window.removeEventListener('online', retryRestore);
    };
  }, [retryRestore]);

  return (
    <CrewTheme>
      <Flex
        vertical
        justify="space-between"
        style={{ minHeight: '100dvh', padding: 24, background: token.colorBgLayout }}
      >
        <Flex vertical align="center" justify="center" gap={12} style={{ flex: 1, textAlign: 'center' }}>
          <DisconnectOutlined style={{ fontSize: 56, color: token.colorWarning }} />
          <Typography.Title level={3} style={{ margin: 0 }}>
            {c.offlineTitle}
          </Typography.Title>
          <Typography.Text type="secondary" style={{ fontSize: 18 }}>
            {c.offlineHint}
          </Typography.Text>
        </Flex>
        <MainButton onClick={retryRestore}>{ru.config.retry}</MainButton>
      </Flex>
    </CrewTheme>
  );
}
